import { useEffect, useState } from 'react';

export const SEARCH_PLACEHOLDERS = [
  'Search by PO #, invoice #, or supplier name…',
  'Try "PO: 614814" to search by PO # 614814',
  'Try "INV: IN000759" to search by invoice # IN000759',
  'Try "SUP: ita security" to search by supplier name "ita security"',
  'Combine with ; (semicolon) e.g. PO: 614814; INV: IN000759; SUP: ita security',
];

/**
 * Cycles through placeholder strings while the input is idle.
 * Pauses when `paused` is true (e.g. focused or has a value).
 */
function useRotatingPlaceholder(
  placeholders = SEARCH_PLACEHOLDERS,
  { intervalMs = 5000, paused = false } = {},
) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (paused || placeholders.length <= 1) return undefined;

    const id = setInterval(() => {
      setIndex((current) => (current + 1) % placeholders.length);
    }, intervalMs);

    return () => clearInterval(id);
  }, [paused, intervalMs, placeholders]);

  return placeholders[index] ?? '';
}

export default useRotatingPlaceholder;
